let ready: Promise<any> | null = null;

import * as bg from "./pkg/core_bg.js";
import wasmBin from "./pkg/core_bg.wasm";

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function toBytes(x: unknown): Uint8Array {
  return x instanceof Uint8Array ? x : new Uint8Array(x as ArrayBuffer);
}

export function loadWasm(): Promise<typeof bg> {
  if (!ready) {
    ready = (async () => {
      if (!isBrowser()) return bg;

      const bytes = toBytes(wasmBin);

      const imports: WebAssembly.Imports = {
        "./core_bg.js": bg as unknown as WebAssembly.ModuleImports,
      };

      const result = await WebAssembly.instantiate(bytes, imports);
      const { instance } = result as unknown as WebAssembly.WebAssemblyInstantiatedSource;

      bg.__wbg_set_wasm(instance.exports);

      if (typeof bg.__wbindgen_init_externref_table === "function") {
        bg.__wbindgen_init_externref_table();
      }

      if (typeof bg.dispatch !== "function") {
        throw new Error("WASM dispatch not found after __wbg_set_wasm");
      }

      return bg;
    })();
  }
  return ready;
}
